<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Scheduled Deliveries</h2>
          <TableLoading v-if="orders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="orders.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <div class="row mb-2">
                <div class="col-3">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Status</label>
                    <select class="form-select" @change="statusFilter($event)">
                      <option value="all" selected>All</option>
                      <option value="e6c0554c-aed8-4c39-b431-cbc239c0fa40">Open</option>
                      <option value="37bd4482-06ed-409d-845e-bdc6334c5505">Not Loaded</option>
                      <option value="b3180af8-62c8-44ce-8432-64c02c5e5a56">Loaded</option>
                    </select>
                  </div>
                </div>
              </div>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>

        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMER_ORDERS_DELIVERIES} from "@/gql/orders";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "Scheduled Deliveries",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, PageHeader, Layout},
  name: "scheduled-deliveries",
  data() {
    return {
      title: "Scheduled Deliveries",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Scheduled Deliveries",
          active: true
        }
      ],
      orders: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      openLoadedNotloadedIds: ['b3180af8-62c8-44ce-8432-64c02c5e5a56', '37bd4482-06ed-409d-845e-bdc6334c5505', 'e6c0554c-aed8-4c39-b431-cbc239c0fa40'],
      columns: [
        {
          field: 'customer.customerCode',
          label: 'Customer Code'
        },
        {
          field: 'customer.name',
          label: 'Customer Name'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'orderTimeZone',
          label: 'Timezone'
        },
        {
          field: 'orderStatus',
          label: 'Status'
        }
      ]
    }
  },
  apollo: {
    orders: {
      query: ALL_CUSTOMER_ORDERS_DELIVERIES,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          orderStatus: this.openLoadedNotloadedIds
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    searchFn(data){
      this.searchKeyword = data
    },
    statusFilter(event){
      const value = event.target.value
      if(event.target.value === 'all'){
        this.openLoadedNotloadedIds = ['b3180af8-62c8-44ce-8432-64c02c5e5a56', '37bd4482-06ed-409d-845e-bdc6334c5505', 'e6c0554c-aed8-4c39-b431-cbc239c0fa40']
      }else {
        this.openLoadedNotloadedIds = [value]
      }
    }
  }
}
</script>

<style scoped>

</style>
